import _ from "lodash";
import { isEmptyDash } from "../../constant";

const getAnsFromOptId = (response, options) => {
  let filterData = options.filter(ele => ele?._id == response?.optionId);
  return filterData[0];
}

const getObjectAns = (str) => {
  if (isEmptyDash(str)) {
    return "";
  } else {
    let arr = str.split("->");
    let str1 = `${arr[0]} | ${arr[1]}`;
    return str1;
  }
  //    return isEmptyDash(str) ? ["", ""] : str.split("->")
}

const getChildAns = (childArr) => {
  let obj = {
    errMsg: "",
    isValid: true,
  }
  for (let i = 0; i < childArr.length; i++) {
    if (childArr[i]?.type == "String") {
      if (isEmptyDash(childArr[i]?.childAnswer)) {
        obj.errMsg = "Please fill out all required fields.";
        obj.isValid = false;
      }
      else if (childArr[i].validation.length > 0) {
        for (let k = 0; k < childArr[i].validation.length; k++) {
          const validationItem = childArr[i].validation[k];
          const regex = new RegExp(validationItem.regex);
          let isRegexValid = regex.test(childArr[i].childAnswer);
          if (!isRegexValid) {
            obj.errMsg = validationItem.errorMsg;
            obj.isValid = false;
            break;
          } else {
            obj.errMsg = '';
          }
        }

      }
    }
    if (childArr[i]?.type == "Dropdown") {
      if (isEmptyDash(childArr[i]?.optionId)) {
        obj.errMsg = "Please fill out all required fields.";
        obj.isValid = false;
      }
    }
    if (childArr[i]?.type == "File") {
      if (childArr[i]?.files.length < 1) {
        obj.errMsg = "Please fill out all required fields.";
        obj.isValid = false;
      }

    }
  }
  return obj;
}

export const isRequiredValid = (secArr) => {
  let sections = _.cloneDeep(secArr);
  let isValid = true;
  let obj = {
    isValid: true
  }
  for (let i = 0; i < sections.length; i++) {
    for (let j = 0; j < sections[i].fields.length; j++) {
      if (sections[i].fields[j].type == 'String' && sections[i].fields[j].required == true) {
        if (isEmptyDash(sections[i].fields[j].answer)) {
          sections[i].fields[j].errMsg = 'Please fill out all required fields.';
          obj.isValid = false;
        } else if (sections[i].fields[j].validation.length > 0) {

          for (let k = 0; k < sections[i].fields[j].validation.length; k++) {
            const validationItem = sections[i].fields[j].validation[k];
            const regex = new RegExp(validationItem.regex);
            let isRegexValid = regex.test(sections[i].fields[j].answer);
            if (!isRegexValid) {
              sections[i].fields[j].errMsg = validationItem.errorMsg;
              obj.isValid = false;
              break;
            } else {
              sections[i].fields[j].errMsg = '';
            }
          }

          /* const regex = new RegExp(sections[i].fields[j].validation[0]?.regex);
           let isRegexValid = regex.test(sections[i].fields[j].answer);
           if (isRegexValid == false) {
             sections[i].fields[j].errMsg = sections[i].fields[j].validation[0]?.errorMsg;
             obj.isValid = false;
           } else {
             sections[i].fields[j].errMsg = '';
           }*/


        } else {
          sections[i].fields[j].errMsg = '';
        }
      }
      if (sections[i].fields[j].type == 'File' && sections[i].fields[j].required == true) {
        //  if (isEmptyDash(sections[i].fields[j].answer)) { 
        if (isEmptyDash(sections[i].fields[j].files[0]?.key)) {
          sections[i].fields[j].errMsg = 'Please select any file.';
          obj.isValid = false;
        } else {
          sections[i].fields[j].errMsg = '';
        }
      }
      if (sections[i].fields[j].type == 'Dropdown' && sections[i].fields[j].required == true) {
        if (isEmptyDash(sections[i].fields[j].optionId)) {
          sections[i].fields[j].errMsg = 'Please fill this required field.';
          obj.isValid = false;
        } else {
          sections[i].fields[j].errMsg = '';
        }
      }
      if (sections[i].fields[j].type == "MultiField" && sections[i].fields[j].required == true) {
        // For MSME Status
        // if (sections[i].fields[j].questionId == "66161cc740f564135022acf2") { 
        //   if (getAnsFromOptId(sections[i].fields[j].child[0], sections[i].fields[j].child[0]?.options)?.optionName == "Yes") { 

        //     if (isEmptyDash(sections[i].fields[j].child[1]?.optionId)) {
        //       sections[i].fields[j].errMsg = 'Please fill this required field.';
        //       obj.isValid = false;
        //     }
        //     else if (isEmptyDash(sections[i].fields[j].child[2]?.childAnswer)) {
        //       sections[i].fields[j].errMsg = 'Please fill this required field.';
        //       obj.isValid = false;
        //     }
        //     //else if (isEmptyDash(sections[i].fields[j].child[3]?.childAnswer)) {
        //     else if (isEmptyDash(sections[i].fields[j].child[3]?.files[0]?.key)) {
        //       sections[i].fields[j].errMsg = 'Please fill this required field.';
        //       obj.isValid = false;
        //     }
        //     else if (sections[i].fields[j].child[2].validation.length > 0) {
        //       const regex = new RegExp(sections[i].fields[j].child[2].validation[0]?.regex);
        //       let isRegexValid = regex.test(sections[i].fields[j].child[2]?.childAnswer); 
        //       if (isRegexValid == false) {
        //         sections[i].fields[j].errMsg = sections[i].fields[j]?.child[2].validation[0]?.errorMsg;
        //         obj.isValid = false;
        //       }
        //       else {
        //         sections[i].fields[j].errMsg = '';
        //       }
        //     }
        //     else {
        //       sections[i].fields[j].errMsg = '';
        //     }


        //     // sections[i].fields[j].errMsg = 'Please fill this required field.';
        //     // obj.isValid = false;            
        //   }
        //   else if (getAnsFromOptId(sections[i].fields[j].child[0], sections[i].fields[j].child[0]?.options)?.optionName == "No") {

        //     if (isEmptyDash(sections[i].fields[j].child[2]?.childAnswer)) {
        //       sections[i].fields[j].errMsg = 'Please fill this required field.';
        //       obj.isValid = false;
        //     }
        //     else {
        //       sections[i].fields[j].errMsg = '';
        //     }
        //   }
        //   else {
        //     sections[i].fields[j].errMsg = 'Please fill this required field.';
        //     obj.isValid = false;
        //   }

        // }

        // // For PAN and GST on Step 1
        // else if (sections[i].fields[j].questionId == "65dda2f33e446a7c0e67c9c7" || sections[i].fields[j].questionId == "65dda2f33e446a7c0e67c9c8") {
        //   if (isEmptyDash(sections[i].fields[j].child[0].optionId)) {
        //     sections[i].fields[j].errMsg = 'Please fill this required field.';
        //     obj.isValid = false;
        //   }
        //   else {
        //     if (getAnsFromOptId(sections[i].fields[j].child[0], sections[i].fields[j].child[0]?.options)?.optionName == "Yes") { 
        //       if (isEmptyDash(sections[i].fields[j].child[1]?.childAnswer)) {
        //         sections[i].fields[j].errMsg = 'Please fill this required field.';
        //         obj.isValid = false;
        //       }
        //       else if (sections[i].fields[j].child[1].validation.length > 0) {
        //         for (let k = 0; k < sections[i].fields[j].child[1].validation.length; k++) {
        //           const validationItem = sections[i].fields[j].child[1].validation[k];
        //           const regex = new RegExp(validationItem.regex);
        //           let isRegexValid = regex.test(sections[i].fields[j].child[1].childAnswer);
        //           if (!isRegexValid) {
        //             sections[i].fields[j].errMsg = validationItem.errorMsg;
        //             obj.isValid = false;
        //             break;
        //           } else {
        //             sections[i].fields[j].errMsg = '';
        //           }
        //         }

        //         /* const regex = new RegExp(sections[i].fields[j].child[1].validation[0]?.regex);
        //          let isRegexValid = regex.test(sections[i].fields[j].child[1]?.childAnswer); 
        //          if (isRegexValid == false) {
        //            sections[i].fields[j].errMsg = sections[i].fields[j]?.child[1].validation[0]?.errorMsg;
        //            obj.isValid = false;
        //          }
        //          else {
        //            sections[i].fields[j].errMsg = '';
        //          }*/


        //       }
        //       else {
        //         sections[i].fields[j].errMsg = '';
        //       }

        //     }

        //     else if (getAnsFromOptId(sections[i].fields[j].child[0], sections[i].fields[j].child[0]?.options)?.optionName == "No") {

        //       if (isEmptyDash(sections[i].fields[j].child[1]?.childAnswer)) {
        //         sections[i].fields[j].errMsg = 'Please fill this required field.';
        //         obj.isValid = false;
        //       }
        //       else {
        //         sections[i].fields[j].errMsg = '';
        //       }

        //     }
        //     else {

        //       sections[i].fields[j].errMsg = '';

        //       // if (isEmptyDash(sections[i].fields[j].child[2]?.childAnswer)) {
        //       // } 
        //       // else {
        //       //   sections[i].fields[j].errMsg = '';
        //       // }          
        //     }

        //   }

        // }

        // // For PAN and GST on Step 2
        // else if (sections[i].fields[j].questionId == "65f83f077ed25e9a383a0172" || sections[i].fields[j].questionId == "65f846297ed25e9a383a017f") {
        //   if (isEmptyDash(sections[i].fields[j].child[1].optionId)) {
        //     sections[i].fields[j].errMsg = 'Please fill this required field.';
        //     obj.isValid = false;
        //   }
        //   else {
        //     if (getAnsFromOptId(sections[i].fields[j].child[1], sections[i].fields[j].child[1]?.options)?.optionName == "Yes") {

        //       //   if (isEmptyDash(sections[i].fields[j].child[0]?.childAnswer)) {
        //       if (isEmptyDash(sections[i].fields[j].child[0]?.files[0]?.key)) {
        //         sections[i].fields[j].errMsg = 'Please fill this required field.';
        //         obj.isValid = false;
        //       }
        //       else if (isEmptyDash(sections[i].fields[j].child[2]?.childAnswer)) {
        //         sections[i].fields[j].errMsg = 'Please fill this required field.';
        //         obj.isValid = false;
        //       }
        //       else {
        //         sections[i].fields[j].errMsg = '';
        //       }

        //     }

        //     else if (getAnsFromOptId(sections[i].fields[j].child[1], sections[i].fields[j].child[1]?.options)?.optionName == "No") {

        //       // if (isEmptyDash(sections[i].fields[j].child[0]?.childAnswer)) {
        //       //   sections[i].fields[j].errMsg = 'Please fill this required field.';
        //       //   obj.isValid = false;  
        //       // }
        //       if (isEmptyDash(sections[i].fields[j].child[2]?.childAnswer)) {
        //         sections[i].fields[j].errMsg = 'Please fill this required field.';
        //         obj.isValid = false;
        //       }
        //       else {
        //         sections[i].fields[j].errMsg = '';
        //       }

        //     }
        //     else {

        //       sections[i].fields[j].errMsg = '';

        //       // if (isEmptyDash(sections[i].fields[j].child[2]?.childAnswer)) {
        //       // } 
        //       // else {
        //       //   sections[i].fields[j].errMsg = '';
        //       // }          
        //     }

        //   }

        // }

        // // For Object on Step 2
        // else if (sections[i].fields[j].questionId == "65dda2f43e446a7c0e67c9eb") {
        //   let isObjectValid = true;
        //   for (let k = 0; k < sections[i].fields[j].child.length; k++) {
        //     if (isEmptyDash(sections[i].fields[j].child[k].childAnswer)) {
        //       isObjectValid = false;
        //     }
        //     else {
        //       let arr = sections[i].fields[j].child[k].childAnswer.split("->");
        //       if (isEmptyDash(arr[0])) {
        //         isObjectValid = false;
        //       }
        //       if (isEmptyDash(arr[1])) {
        //         isObjectValid = false;
        //       }
        //     }
        //   }
        //   if (isObjectValid) {
        //     sections[i].fields[j].errMsg = '';
        //   }
        //   else {
        //     sections[i].fields[j].errMsg = 'Please fill this required field.';
        //     obj.isValid = false;
        //   }

        // }

        // // For Multi on Step 3
        // else if (sections[i].fields[j].questionId == "65dda2f43e446a7c0e67c9ff" || sections[i].fields[j].questionId == "65dda2f43e446a7c0e67ca06") {

        //   if (isEmptyDash(sections[i].fields[j].child[0]?.childAnswer)) {
        //     sections[i].fields[j].errMsg = 'Please fill this required field.';
        //     obj.isValid = false;
        //   }
        //   else if (isEmptyDash(sections[i].fields[j].child[1]?.childAnswer)) {
        //     sections[i].fields[j].errMsg = 'Please fill this required field.';
        //     obj.isValid = false;
        //   }
        //   else if (sections[i].fields[j].child[0].validation.length > 0) {
        //     const regex = new RegExp(sections[i].fields[j].child[0].validation[0]?.regex);
        //     let isRegexValid = regex.test(sections[i].fields[j].child[0]?.childAnswer); 
        //     if (isRegexValid == false) {
        //       sections[i].fields[j].errMsg = sections[i].fields[j]?.child[0].validation[0]?.errorMsg;
        //       obj.isValid = false;
        //     }
        //     else {
        //       sections[i].fields[j].errMsg = '';
        //     }
        //   }
        //   else if (sections[i].fields[j].child[1].validation.length > 0) {
        //     const regex = new RegExp(sections[i].fields[j].child[1].validation[0]?.regex);
        //     let isRegexValid = regex.test(sections[i].fields[j].child[1]?.childAnswer); 
        //     if (isRegexValid == false) {
        //       sections[i].fields[j].errMsg = sections[i].fields[j]?.child[1].validation[0]?.errorMsg;
        //       obj.isValid = false;
        //     }
        //     else {
        //       sections[i].fields[j].errMsg = '';
        //     }
        //   }
        //   else {
        //     sections[i].fields[j].errMsg = '';
        //   }

        // }

        // For all Multifields
        if (sections[i].fields[j].isConditional == true) {
          let filetConditionalData = sections[i].fields[j].child.filter(ele => ele.isDeciding == true);
          if (isEmptyDash(filetConditionalData[0].optionId)) {
            sections[i].fields[j].errMsg = 'Please fill this required field.';
            obj.isValid = false;
          } else {
            let filterConditionalAnsData = sections[i].fields[j].child.filter(ele => ele.refOptionId == filetConditionalData[0].optionId);
            let ansData = getChildAns(filterConditionalAnsData);
            sections[i].fields[j].errMsg = ansData?.errMsg;
            if (ansData?.isValid == false) {
              obj.isValid = ansData?.isValid;
            }
          }
        }
        else {
          for (let k = 0; k < sections[i].fields[j].child.length; k++) {
            let childData = sections[i].fields[j].child[k];
            if (childData?.type == "String") {
              if (isEmptyDash(childData.childAnswer)) {
                sections[i].fields[j].errMsg = 'Please fill out all required fields.';
                obj.isValid = false;
              } else if (childData.validation.length > 0) {

                for (let q = 0; q < childData.validation.length; q++) {
                  const validationItem = childData.validation[q];
                  const regex = new RegExp(validationItem.regex);
                  let isRegexValid = regex.test(childData.childAnswer);
                  if (!isRegexValid) {
                    sections[i].fields[j].errMsg = validationItem.errorMsg;
                    obj.isValid = false;
                    break;
                  } else {
                    sections[i].fields[j].errMsg = '';
                  }
                }

              } else {
                sections[i].fields[j].errMsg = '';
              }

            }
            if (childData?.type == "File") {
              if (childData?.files.length < 1) {
                sections[i].fields[j].errMsg = "Please fill out all required fields.";
                obj.isValid = false;
              }

            }
            if (childData?.type == "Dropdown") {
              if (isEmptyDash(childData?.optionId)) {
                sections[i].fields[j].errMsg = "Please fill out all required fields.";
                obj.isValid = false;
              }

            }
            if (childData?.type == "Object") {
              let isObjectValid = true;
              if (isEmptyDash(childData.childAnswer)) {
                isObjectValid = false;
                sections[i].fields[j].errMsg = 'Please fill this required field.';
                obj.isValid = false;
              }
              else {
                let arr = childData.childAnswer.split("->");

                for (let x = 0; x < childData.validation.length; x++) {
                  const validationItem = childData.validation[x];
                  const regex = new RegExp(validationItem.regex);
                  let isRegexValid1 = regex.test(arr[0]);
                  let isRegexValid2 = regex.test(arr[1]);
                  if (isRegexValid1 && isRegexValid2) {
                    // sections[i].fields[j].errMsg = '';
                  } else {
                    sections[i].fields[j].errMsg = validationItem.errorMsg;
                    obj.isValid = false;
                    break;
                  }
                }

              }

              // if (isObjectValid) {
              //   sections[i].fields[j].errMsg = '';
              // }
              // else {
              //   sections[i].fields[j].errMsg = 'Please fill this required field.';
              //   obj.isValid = false;
              // }
            }

          }
          // if (isEmptyDash(sections[i].fields[j].child[0].optionId)) {
          //   sections[i].fields[j].errMsg = 'Please fill this required field.';
          //   obj.isValid = false;
          // }
          // else {
          //   if (getAnsFromOptId(sections[i].fields[j].child[0], sections[i].fields[j].child[0]?.options)?.optionName == "Yes") {

          //     if (isEmptyDash(sections[i].fields[j].child[1]?.childAnswer)) {
          //       sections[i].fields[j].errMsg = 'Please fill this required field.';
          //       obj.isValid = false;
          //     }
          //     else if (sections[i].fields[j].child[1].validation.length > 0) {
          //       const regex = new RegExp(sections[i].fields[j].child[1].validation[0]?.regex);
          //       let isRegexValid = regex.test(sections[i].fields[j].child[1]?.childAnswer); 
          //       if (isRegexValid == false) {
          //         sections[i].fields[j].errMsg = sections[i].fields[j]?.child[1].validation[0]?.errorMsg;
          //         obj.isValid = false;
          //       }
          //       else {
          //         sections[i].fields[j].errMsg = '';
          //       }
          //     }
          //     else {
          //       sections[i].fields[j].errMsg = '';
          //     }

          //   }
          //   else {
          //     sections[i].fields[j].errMsg = '';
          //   }

          // }

        }



        // if (isEmptyDash(sections[i].fields[j].optionId)) { 
        //   sections[i].fields[j].errMsg = 'Please fill this required field.';
        //   obj.isValid = false;            
        // } else {
        //   sections[i].fields[j].errMsg = '';             
        // }
      }

    }
  }

  obj.sections = [...sections];
  return obj;
}